/**
 * Client-side category filtering for the testimonials section.
 *
 * Purely presentational: it shows/hides already-rendered cards. There is no
 * review backend here. When a Shopify review app is connected later, the app's
 * output can replace the `.testimonials__item[data-category]` markup and this
 * component keeps working unchanged.
 */
class TestimonialFilters extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.testimonials');
    if (!this.section) return;

    this.items = Array.from(this.section.querySelectorAll('.testimonials__item'));
    this.emptyMessage = this.section.querySelector('.testimonials__empty');
    this.buttons = Array.from(this.querySelectorAll('.testimonials__filter'));

    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const button = event.target.closest('.testimonials__filter');
    if (!button) return;

    const filter = button.dataset.filter;

    for (const other of this.buttons) {
      other.setAttribute('aria-pressed', String(other === button));
    }

    let visible = 0;
    for (const item of this.items) {
      const matches = filter === 'all' || item.dataset.category === filter;
      item.hidden = !matches;
      if (matches) visible++;
    }

    if (this.emptyMessage) this.emptyMessage.hidden = visible > 0;
  };
}

if (!customElements.get('testimonial-filters')) {
  customElements.define('testimonial-filters', TestimonialFilters);
}
